/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Button from './Button';

export default function TryItOut() {
  const { t, i18n } = useTranslation('site');
  const navigate = useNavigate();

  return (
    <div className="bg-white">
      <div className="mx-auto max-w-7xl py-16 sm:px-6 lg:px-8">
        <div className="relative isolate overflow-hidden bg-brandBlue-800 px-6 pt-16 shadow-2xl sm:rounded-3xl sm:px-16 md:pt-24 lg:flex lg:gap-x-20 lg:px-24 lg:pt-0">
          <svg
            viewBox="0 0 1024 1024"
            className="absolute left-1/2 top-1/2 -z-10 h-[64rem] w-[64rem] -translate-y-1/2 [mask-image:radial-gradient(closest-side,white,transparent)] sm:left-full sm:-ml-80 lg:left-1/2 lg:ml-0 lg:-translate-x-1/2 lg:translate-y-0"
            aria-hidden="true"
          >
            <circle cx={512} cy={512} r={512} fill="url(#759c1415-0410-454c-8f7c-9a820de03641)" fillOpacity="0.7" />
            <defs>
              <radialGradient id="759c1415-0410-454c-8f7c-9a820de03641">
                <stop stopColor="#68BBF7" />
                <stop offset={1} stopColor="#A2D5FA" />
                {/* <stop stopColor="#7775D6" />
                <stop offset={1} stopColor="#E935C1" /> */}
              </radialGradient>
            </defs>
          </svg>
          <div className="mx-auto max-w-md text-center lg:mx-0 lg:flex-auto lg:py-32 lg:text-left">
            <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
              {t('features.section4.cta.header')}
              <br />
              {t('features.section4.cta.header2')}
            </h2>
            <p className="mt-6 text-lg leading-8 text-gray-300">
              {t('features.section4.cta.subheader')}
            </p>
            <div className="mt-10 flex items-center justify-center gap-x-4 lg:justify-start">
              <Button
                text={t('site:general.freetrial')}
                onClick={() => navigate(`/${i18n.language}/register`)}
              />
              <Button
                text={t('site:general.startDemo')}
                onClick={() => navigate(`/${i18n.language}/demo`)}
                noFrame
                onDarkBackground
              />
            </div>
          </div>
          <div className="relative mt-16 h-80 lg:mt-8">
            <img
              className="absolute left-0 top-0 w-[57rem] max-w-none rounded-md bg-white/5 ring-1 ring-white/10"
              src="https://tailwindui.com/img/component-images/dark-project-app-screenshot.png"
              alt="App screenshot"
              width={1824}
              height={1080}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
